import {SortableContext, verticalListSortingStrategy} from "@dnd-kit/sortable";

import {SortableContextWrapperProps} from "./SortableContextWrapper.types";

export const SortableContextWrapper = <TData,>({children, isDragAndDrop, rows}: SortableContextWrapperProps<TData>) => {
  if (!isDragAndDrop) {
    return <>{children}</>;
  }
  // key with Date.now() to force remounting SortableContext this is because for some reason refs to the draggable rows
  //    are not set in the dnd context on first render sometimes adding in this forced remount seems to fix it
  return (
    <SortableContext key={Date.now()} items={rows} strategy={verticalListSortingStrategy}>
      {children}
    </SortableContext>
  );
};
